import { Component, OnInit, Input } from '@angular/core'
import { Observable, of } from 'rxjs'
import { AuthService, User } from '@spartacus/core'
import { Router } from '@angular/router'
import { QuoteCartService } from '../../../quote-services/quote-cart.service'
import { switchMap } from 'rxjs/operators'
import { UserAccountFacade } from '@spartacus/user/account/root'

@Component({
  standalone: false,
  selector: 'vs-line-items',
  templateUrl: './line-items.component.html',
  styleUrls: ['./line-items.component.scss'],
})
export class LineItemsComponent implements OnInit {
  @Input() cartData$: Observable<any>
  userType: string
  user$: Observable<User>
  cartId: any
  cartLoaded = false
  productData: any
  isLoggedinUser = false
  reasonForQuoteArray$: Observable<any>
  reasonForQuote: any
  constructor(
    private quoteService: QuoteCartService,
    private auth: AuthService,

    private router: Router,
    private userAccountFacade: UserAccountFacade
  ) {}

  ngOnInit(): void {
    this.user$ = this.auth.isUserLoggedIn().pipe(
      switchMap((isUserLoggedIn) => {
        if (isUserLoggedIn) {
          this.userType = 'current'
          return this.userAccountFacade.get()
        } else {
          this.userType = 'anonymous'
          return of(undefined)
        }
      })
    )
    this.auth.isUserLoggedIn().subscribe((success) => {
      if (success) {
        this.isLoggedinUser = success
        this.userType = 'current'
      } else {
        this.userType = 'anonymous'
      }
    })
    // this.auth.getUserToken().subscribe((data) => {
    //   this.token = data.access_token;
    // });
    this.reasonForQuoteArray$ = this.quoteService.getQuoteReason(this.userType)
    this.reasonForQuoteArray$.subscribe((res) => {
      this.reasonForQuote = res.reasonforQuote
    })
    // this.getCartData();
  }

  getCartData() {
    if (this.userType === 'current') {
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-current')
    }
    if (this.userType === 'anonymous') {
      this.cartId = this.cartId
        ? this.cartId
        : sessionStorage.getItem('cartId-anonymous')
    }
    this.cartData$ = this.quoteService.getCart(this.cartId, this.userType)
    this.cartData$.subscribe(
      (success: any) => {
        this.cartLoaded = true
        this.productData = success.entries
        if (this.productData.length < 1) {
          if (this.userType === 'current') {
            sessionStorage.setItem('cartId-current', '')
          }
          if (this.userType === 'anonymous') {
            sessionStorage.setItem('cartId-anonymous', '')
          }
        }
      },
      (error) => {}
    )
  }

  refreshList(event) {
    // this.cartStatus = event;
    // sessionStorage.setItem('cartStaus', this.cartStatus);
    this.getCartData()
    this.router.navigate(['quote/cart'])
  }
}
